<div class="chat-right-panel">
  <div class="chats-panel-header">
    <h1 class="chats-title">Chats</h1>
    <div class="chats-actions">
      <button nz-button nzType="primary" class="btn-new-chat-premium" (click)="createNewChat()">
        <svg-icon svgClass="new-chat-icon" src="assets/icons/plus.svg" alt="New Chat" />New Chat
      </button>
    </div>
  </div>

  <div class="chats-loading-state" *ngIf="isLoading">
    <gains-spinner></gains-spinner>
  </div>

  <div class="chat-search-row-premium" *ngIf="!isLoading && allChats.length > 0">
    <div class="search-container-premium">
      <gains-input [required]="false" placeholder="Search chats..." icon="assets/icons/search.svg" [customFormControl]="searchControl"></gains-input>
    </div>
  </div>

  <!-- Chat Failed State, above the list: a locally created chat can exist while the full list is still
       unknown, so the failure is reported as a banner over those rows rather than replacing them. -->
  <deo-panel-state
    *ngIf="!isLoading && loadError"
    mode="error"
    title="Couldn't load chats"
    [message]="loadError"
    [layout]="filteredChats.length > 0 ? 'banner' : 'block'"
    (retry$)="retry$.emit()"
  ></deo-panel-state>

  <div class="section-premium" *ngIf="!isLoading && filteredChats.length > 0">
    <div
      class="chat-card-premium"
      *ngFor="let session of filteredChats; trackBy: trackBySessionId"
      [class.active]="currentSessionId === session.id"
      (click)="selectChat(session.id)"
      (keydown.enter)="selectChat(session.id)"
      (keydown.space)="selectChat(session.id)"
      tabindex="0"
    >
      <div class="card-top-row">
        <div class="card-side-selection">
          <label *ngIf="canManage(session)" class="custom-checkbox" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <input
              type="checkbox"
              [checked]="isSessionSelected(session.id)"
              [attr.aria-label]="'Select chat ' + session.title"
              (change)="toggleSessionSelection(session.id, $event)"
              (keydown.enter)="onCheckboxKey($event, session.id)"
              (keydown.space)="onCheckboxKey($event, session.id)"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="card-title-container">
          <span class="chat-card-title">{{ session.title }}</span>
        </div>

        <div class="card-actions-right" *ngIf="canManage(session)">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            class="star-btn"
            (click)="toggleStar(session.id, $event)"
            [attr.aria-label]="session.isFavorite ? 'Unstar chat' : 'Star chat'"
            [attr.aria-pressed]="session.isFavorite"
          >
            <svg-icon [src]="session.isFavorite ? 'assets/icons/favorite-filled.svg' : 'assets/icons/favorite.svg'" aria-hidden="true" />
          </button>
          <gains-ellipsis-menu
            class="card-menu"
            [menuItems]="chatMenuItems"
            [dropdownWidth]="'200px'"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            (changeEvent)="onChatMenuAction($event, session)"
          ></gains-ellipsis-menu>
        </div>
      </div>

      <div class="card-bottom-row">
        <div class="card-meta-row">
          <span class="card-date">{{ formatDate(session.last_message_at || session.created_at) }}</span>
          <span class="card-meta-divider">·</span>
          <div class="artifact-meta-item">
            <svg-icon src="assets/icons/files-content.svg" svgClass="meta-icon" title="Artifacts" />
            <span class="artifact-count-text">{{ getArtifactCount(session) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat Empty State -->
  <deo-panel-state *ngIf="!isLoading && !loadError && filteredChats.length === 0" mode="empty" icon="assets/icons/chat.svg" title="No Chat Found"></deo-panel-state>

  <gains-bulk-actions-drawer [selectedItems]="selectedSessionIds">
    <div class="selection-info">
      <span class="selection-count">{{ selectedSessionIds.length }} chat(s) selected</span>
    </div>
    <button *ngIf="isProjectsEnabled" nz-button nzType="default" (click)="bulkMoveToProject()">
      <svg-icon src="assets/icons/circle-check.svg" title="Move" />
      Move to Project
    </button>
    <button nz-button nzType="default" nzDanger (click)="bulkDeleteSessions($event)">
      <svg-icon src="assets/icons/trash-1.svg" title="Delete" />
      Delete
    </button>
  </gains-bulk-actions-drawer>
</div>
